import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import Box from './Box';

import Theme from '../../../styles/Theme/Theme';
import { mediaUp } from '../../../styles/Shared/MediaQueries';

type TStyledLine = {
    customColor: keyof typeof Theme.color;
    completed: boolean;
    current: boolean;
    isThick: boolean;
}

const StyledLine = styled(Box)<TStyledLine>`
    width: 100%;
    border-bottom-style: solid;
    border-bottom-width: ${({ isThick }) => (isThick ? '5px' : '2px')};
    border-bottom-color: ${({ customColor, theme }) => `${theme.color[customColor]}`};
    cursor: ${({ completed, current }) => (completed && !current ? 'pointer' : 'default')};
    pointer-events: ${({ completed }) => (completed ? 'auto' : 'none')};

    ${mediaUp.medium} {
        &:hover {
            background: ${({ completed, current, theme }) => (completed && !current ? theme.color['neutral2'] : null)};
        }
    }
`;

type TProps = {
    step: number;
    maxStep: number;
    stepIsValid: boolean;
    setStep: (number: number) => void
}

const ProgressTracker = (props: TProps) => {
    const { maxStep, step, stepIsValid } = props;

    // Hooks
    const [stepsData, setStepsData] = useState<any>([]);

    const handleStepClick = (e: any, index: number) => {
        const { setStep } = props;
        e.preventDefault();

        setStep(index);
    };

    // ComponentDidMount
    useEffect(() => {
        let updatedSteps = [];

        for (let i = 1; i <= maxStep; i++) {
            updatedSteps.push({
                current: step === i ? true : false,
                completed: (i <= step) || (i === step && stepIsValid),
            })
        }

        setStepsData(updatedSteps);
    }, [maxStep, step, stepIsValid]);

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center">
            {stepsData.map((item: any, id: number) => {
                const { current, completed } = item;

                return (
                    <StyledLine
                        key={id}
                        mx={id === 0 || id === maxStep - 1 ? undefined : "md"}
                        py="md"
                        flexGrow={1}
                        isThick={completed}
                        completed={completed}
                        current={current}
                        onClick={(e) => handleStepClick(e, id + 1)}
                        customColor={current && completed ? 'green-nova' : !current && completed ? 'black-1' : 'coolgray-2'}
                    />
                )
            })}
        </Box>
    );
}

export default ProgressTracker;